module.exports = __webpack_public_path__ + "b3cb9a02ee1d3385da7897f7d0bdd875.eot";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Bold.eot
// module id = 14
// module chunks = 0